module.exports = __webpack_public_path__ + "img/ic-no-data.53a49186.svg";